<template src= "./index.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'

export const BtnDelete = Vue.extend({
  name : 'btnDelete',
  template: `
        <div>
            <vs-button v-if="bizregistration" style="width:100%;" class="btnSmall" :disabled="!bizregistration" :href="bizregistration.remote_path" target="_blank" @click="btnClickedHandler2()" >사업자등록증</vs-button> 
            <vs-button v-else style="width:100%;" class="btnSmall" :disabled="true"  target="_blank" @click="btnClickedHandler2()" >사업자등록증</vs-button> 
        </div>
    `,
  data(){
    return{
      title : '',
      bizregistration : null
    }
  },
  created(){
    this.title = this.params.colDef.headerName
    this.bizregistration = this.params.data.aggregator.bizregistration
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    },
    btnClickedHandler2() {
      this.params.clicked2(this.params.data);
    }
  },
});

export default {
    name: 'genreList',
  
    data () {
        return {
            ko : ko,
            startDate : null,
            endDate : null,

            aggregatorOption : [
                {id : null, name : '전체'}
            ],
            aggregator : null,

            total : 0,
            page: {
                pageSize : 10,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },          
            gridOptions :{ // 테이플 옵션
                context: {
                    componentParent: this
                },
                onRowClicked: (event)=>{
                    this.viewDetail(event)
                },
                frameworkComponents : {
                    btnDelete : BtnDelete,
                }
            },
            defaultColDef: {
                sortable: false,
                editable: false,
                resizable: true,
                suppressMenu: false,
                rowSelection:'single'
            },
            columnDefs: [
                // aggregator_id: 1
                // amount: 10000
                // created_at: "2021-08-19T06:37:10.307Z"
                // deposit_date: "2020-03-03"
                // id: 1
                // item: "품목"
                // month: "2021-06"
                // note: "비고"
                // settlement_amount: 11000
                // tax_invoice_date: "2020-03-03"
                // updated_at: "2021-08-19T06:37:10.307Z"
                // vat: 1000

                {headerName: '매출월',      field: 'month',     filter: false,width: 100,
                cellRenderer: (data) => {
                return this.fixDate(data.value, 'yyyy-MM')
                }},
                {headerName: '계약사',  field: 'aggregator.name',  filter: false,width: 150},
                // {headerName: '계약사(Display)파트너사',    field: 'display_name',   filter: false,width: 150},
                {headerName: '정산액',    field: 'amount',   filter: false,width: 200,cellRenderer: (data) => {
                return this.numberFormat(data.value)
                }},
                {headerName: 'VAT',    field: 'vat',   filter: false,width: 200,cellRenderer: (data) => {
                return this.numberFormat(data.value)
                }},
                {headerName: '금액',    field: 'settlement_amount',   filter: false,width: 200,cellRenderer: (data) => {
                return this.numberFormat(data.value)
                }},
                {headerName: '세금계산서발행일',    field: 'tax_invoice_date',   filter: false,width: 150},
                {headerName: '입금확인일',    field: 'deposit_date',   filter: false,width: 150},
                {headerName: '품목',    field: 'item',   filter: false,width: 200},
                {headerName: 'TAX수신메일',    field: 'aggregator.email',   filter: false,width: 200},
                
                {headerName: '사업자등록증', field: 'id', filter: false,minWidth: 140,
                    cellRendererParams: {
                        clicked: function(data) {
                            //this.context.componentParent.genreEdit(data.id);
                        },
                        clicked2 : function(data) {
                            
                            //this.context.componentParent.genreDelete(data.id);
                        }

                    },
                    cellRenderer: 'btnDelete'
                },
                {headerName: '등록일',      field: 'created_at',     filter: false,width: 200,
                cellRenderer: (data) => {
                return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
                }},
                {headerName: '업데이트일',      field: 'updated_at',     filter: false,width: 200,
                cellRenderer: (data) => {
                return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
                }},
            ],
            tableData:[
            ],       
            
            testMessage: "최고당!",

            
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.aggregator_id){
            this.aggregator = this.$route.query.aggregator_id
        }
        if(this.$route.query['date_start'] && this.$route.query['date_end'] ) {
            this.startDate = this.$route.query['date_start'] 
            this.endDate = this.$route.query['date_end'] 
        }
        
    },
    mounted(){
        this.$nextTick(() =>{
            this.callAggregator()
            this.callList()
            
        })
    },
    computed: {
        
    },
    watch: {
        'page.currentPage'(e){
            
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        }
    },
    methods: {
       
        resetSearch(){
            this.startDate = null
            this.endDate = null
            this.aggregator = null
        },
        callList(){
            const option = {
                sort: 'id',
                sortorder: 'desc',
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
                
            }
        
        let query = {}
        // if(!this.valCheck(this.keywordType) && !this.valCheck(this.keyword)) {
        //     option[this.keywordType.value] = this.keyword
        //     query[this.keywordType.value] = this.keyword
        // }
        if(!this.valCheck(this.startDate )&& !this.valCheck(this.endDate) ){
          option['date_start'] = this.startDate
          option['date_end'] = this.endDate
          query['date_start'] = this.startDate
          query['date_end'] = this.endDate
        }
        if(this.page.currentPage != 1){
          query['page'] = this.page.currentPage
        }
        if(this.aggregator && this.aggregator !='') {
            option['aggregator_id'] = this.aggregator
            query['aggregator_id'] = this.aggregator
        }
      

        // if(this.roleType && this.roleType !='') {
        //     option['role'] = this.roleType.value
        // }
        // const param = {
        //     page: this.currentPage - 1,
        //     limit: this.pagingPerPage,
        //     sort: 'id',
        //     sortorder: 'desc',
            
        // }
        this.$router.replace({query: query}).catch((e)=>{});
        this.$store.dispatch('LIST_SETTLEMENT', option)
        .then(result =>{
            this.loadingHide();
            this.tableData  = result.items // 권리자 목록
            
            this.total = result.total // 총인원수 
            this.filtered = result.filtered // limit에 따른 수
            //페이지 수
            const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
            this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
        }).catch(error=>{
          const status = error.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
              this.alert({msg:error.response.data.message})
            break;
          }
        })
        },
        
        list_search(){
            this.page.currentPage = 1  // 초기화
            this.callList()
        },
        callAggregator(){
            const option = {
                sort: 'created_at',
                sortorder: 'desc',
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
                //is_various_artists: false, // 필수 filter
            }
            
            let query = {}

            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(this.keywordType && !this.valCheck(this.keyword) ) {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword
            }   
            this.$router.replace({query: query}).catch((e)=>{});
            
            this.loadingShow()

            this.$store.dispatch('GET_AGGREGATOR', option)
            .then(result =>{
                this.loadingHide()
                this.aggregatorOption  = [
                    {id : null, name :'전체'},
                    ...result
                ] // 권리자 목록
                
                this.total = result.length // 총인원수 
                
                //페이지 수
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        viewDetail(event){
            this.$router.push('taxinvoice/detail/'+event.data.id)
        },
        getExcelFile(response){
            let filename = "",
                disposition = response.headers["content-disposition"];
                
            if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/, matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }

            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
                window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                    filename);
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            }
        },
        getExcel(){
            const option = {
            }
            let query = {}
            if(!this.valCheck(this.startDate )&& !this.valCheck(this.endDate) ){
                option['sales_month_start'] = this.startDate
                option['sales_month_end'] = this.endDate
            }
            if(this.aggregator && this.aggregator !='') {
                option['aggregator_id'] = this.aggregator
            }

            this.loadingShow();
            this.$store.dispatch('EXCEL_SETTLEMENT', option)
            .then(result =>{
                this.loadingHide();
                console.log('result',result)
                this.getExcelFile(result)
            }).catch(error=>{
            const status = error.status
            switch(status){
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                this.alert({msg:error.response.data.message})
                break;
            }
            })
        
        },
    }
}
</script>

<style scoped>

</style>
